import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from '@monorepo/shared-auth';
import { CartProvider } from './contexts/CartContext';
import Navigation from './components/layout/Navigation/Navigation';
import Footer from './components/layout/Footer/Footer';
import ProtectedRoute from './components/auth/ProtectedRoute';
import UBuniverse from './pages/UBuniverse/UBuniverse';
import Shop from './pages/Shop/Shop';
import SoftwareSolutions from './pages/SoftwareSolutions/SoftwareSolutions';
import UBUnited from './pages/UBUnited/UBUnited';
import Leagues from './pages/Leagues/Leagues';
import LeagueDetail from './pages/LeagueDetail/LeagueDetail';
import LeagueInvite from './pages/LeagueInvite/LeagueInvite';
import SportDetail from './pages/SportDetail/SportDetail';
import Auth from './pages/Auth/Auth';
import ProfileSetup from './pages/ProfileSetup/ProfileSetup';
import Profile from './pages/Profile/Profile';
import Pricing from './pages/Pricing/Pricing';
import NewProjects from './pages/NewProjects/NewProjects';
import './styles/global.css';
import './styles/ubsports.css';
import './styles/league-system.css';

const AppContent = () => {
  return (
    <>
      <Navigation />
      <Routes>
        <Route path="/" element={<UBuniverse />} />
        <Route path="/ubunited" element={<UBUnited />} />
        <Route path="/software" element={<SoftwareSolutions />} />
        <Route path="/shop" element={<Shop />} /> {/* Hidden route - still accessible via direct URL */}
        <Route path="/sports/:sportId" element={<SportDetail />} />
        <Route path="/auth" element={<Auth />} />
        <Route path="/profile-setup" element={<ProfileSetup />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/newprojects" element={<NewProjects />} />
        <Route path="/league-invite/:token" element={<LeagueInvite />} />
        <Route
          path="/profile"
          element={
            <ProtectedRoute>
              <Profile />
            </ProtectedRoute>
          }
        />
        <Route path="/leagues" element={<Leagues />} />
        <Route path="/leagues/:leagueId" element={<LeagueDetail />} />
      </Routes>
      <Footer />
    </>
  );
};

const App = () => {
  return (
    <Router>
      <AuthProvider siteId="ubsports">
        <CartProvider>
          <AppContent />
        </CartProvider>
      </AuthProvider>
    </Router>
  );
};

export default App;
